// ---------------
// FICHIER : src/App.js (MIS À JOUR)
// ---------------
import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Navigate,
  Routes,
  Route,
} from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import TabBar from "./components/TabBar";
import Home from "./pages/Home";
import Solutions from "./pages/Solutions";
import About from "./pages/About";
import Pricing from "./pages/Pricing";
import Contact from "./pages/Contact";
import Business from "./pages/Business";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import MasomoPrivacy from "./pages/MasomoPrivacy";
import Compliance from "./pages/Compliance";
import FAQ from "./pages/FAQ";
import SMSDoc from "./pages/SMSDoc";
import MailDoc from "./pages/MailDoc";
import DownloadApp from "./pages/DownloadApp";
import StoreRedirect from "./pages/StoreRedirect";
import BlogDetail from "./pages/BlogDetail";
import ContentArchive from "./pages/ContentArchive";
import Clients from "./pages/Clients";
import {
  API_PORTAL_URL,
  MASOMO_SMART_DOWNLOAD_PATH,
  WONYAPAY_SMART_DOWNLOAD_PATH,
} from "./constants/links";
import { LanguageProvider, useLanguage } from "./i18n/LanguageProvider";
import { ThemeProvider } from "./theme/ThemeProvider";

import "./App.css";
import "./modern-site.css";
import "./legacy-dark-theme.css";
import "./dark-theme.css";
import "./mobile-navigation.css";

function ExternalRedirect({ to }) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);

  return null;
}

function AppContent() {
  const { t } = useLanguage();

  return (
    <>
      <a className="ws-skip-link" href="#main-content">
        {t("Aller au contenu principal")}
      </a>
      <Header />
      <main id="main-content" tabIndex="-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/about" element={<About />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/business" element={<Business />} />
          <Route path="/blog/:id" element={<BlogDetail />} />
          <Route path="/blog" element={<ContentArchive section="blog" />} />
          <Route
            path="/testimonials"
            element={<ContentArchive section="testimonials" />}
          />
          <Route path="/clients" element={<Clients />} />
          <Route
            path="/documentation"
            element={<ExternalRedirect to={API_PORTAL_URL} />}
          />
          <Route path="/sms-doc" element={<SMSDoc />} />
          <Route path="/mail-doc" element={<MailDoc />} />
          <Route path="/appmobile" element={<DownloadApp />} />
          <Route path={WONYAPAY_SMART_DOWNLOAD_PATH} element={<StoreRedirect application="wonyapay" />} />
          <Route path={MASOMO_SMART_DOWNLOAD_PATH} element={<StoreRedirect application="masomo" />} />
          <Route
            path="/appMobile"
            element={<Navigate to="/appmobile" replace />}
          />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/privacy/masomo" element={<MasomoPrivacy />} />
          <Route path="/compliance" element={<Compliance />} />
        </Routes>
      </main>
      <TabBar />
      <Footer />
    </>
  );
}

function App() {
  return (
    <Router>
      <ThemeProvider>
        <LanguageProvider>
          <AppContent />
        </LanguageProvider>
      </ThemeProvider>
    </Router>
  );
}

export default App;
